export const imageUrl = [
  "https://invernessindia.com/wp-content/uploads/2023/08/Invernerss-Ear-Piercing-Ness-Headers-2023-Brightness.jpg",
  "https://invernessindia.com/wp-content/uploads/2023/08/Invernerss-Ear-Piercing-Ness-Headers-2023-Loveliness-2.jpg",
  "https://invernessindia.com/wp-content/uploads/2023/08/Invernerss-Ear-Piercing-Ness-Headers-2023-Friendliness.jpg",
];
